<div *ngIf="block" [ngClass]="margin !== '' ? margin : 'm-2'">
    <div *ngIf="!isExport" class="container-card-pagine d-flex flex-column justify-content-between no-print"
        [ngStyle]="{'background-image': block.field_immagine ? 'url(' + imgPath + ')' : ''}"
        [ngClass]="block.field_immagine ? 'image' : 'bg-brand-99'">
        <div *ngIf="this.block && this.block.field_tassonomia_area_universita && this.block.field_tassonomia_area_universita.length" class="d-flex flex-wrap z-index">
            <p class="mb-1 me-2 ls-label-small-semibold text-uppercase" [ngClass]="block.field_immagine ? 'text-neutral-80' : 'text-neutral-60'" [innerHTML]="taxonomies"></p>
        </div>
        <div class="z-index">
            <a *ngIf="dataTitle.title" [routerLink]="navigationService.splitUrlRouterLink(dataTitle.link).path" [queryParams]="navigationService.splitUrlRouterLink(dataTitle.link).queryParams">
                <h3 *ngIf="!isLinkEsternal" class="ls-h3-item-title cursor-pointer"
                    [ngClass]="block.field_immagine ? 'text-neutral-95' : 'text-brand-10'"
                    [innerHTML]="dataTitle.title"></h3>
            </a>
            <a *ngIf="isLinkEsternal" [href]="dataTitle.link" target="_blank">
                <h3 class="ls-h3-item-title cursor-pointer"
                    [ngClass]="block.field_immagine ? 'text-neutral-95' : 'text-brand-10'"
                    [innerHTML]="dataTitle.title"></h3>
            </a>
            <a *ngIf="!isLinkEsternal" [routerLink]="navigationService.splitUrlRouterLink(dataTitle.link).path" [queryParams]="navigationService.splitUrlRouterLink(dataTitle.link).queryParams">
                <div class="container-card-pagine__button-bottom cursor-pointer">
                    <div class="m-0 ls-label-medium-semibold container-card-pagine__button-bottom__button" [ngClass]="{
                    'text-neutral-A1 line-discover-with-icon-white': block.field_immagine,
                    'text-brand-40 line-discover-with-icon': !block.field_immagine
                }">
                        <p class="ls-label-medium-semibold text-uppercase">{{"FIND_OUT" | translate}}</p>
                        <i class="fa-solid fa-arrow-right pb-4" aria-hidden="true"
                            [ngClass]="block.field_immagine ? 'text-neutral-A1' : 'text-brand-40'"></i>
                    </div>
                </div>
            </a>
            <a *ngIf="isLinkEsternal" [href]="dataTitle.link" target="_blank">
                <div class="container-card-pagine__button-bottom">
                    <div class="m-0 ls-label-medium-semibold container-card-pagine__button-bottom__button" [ngClass]="{
                            'text-neutral-A1 line-discover-with-icon-white': block.field_immagine,
                            'text-brand-40 line-discover-with-icon': !block.field_immagine
                        }">
                        <p class="ls-label-medium-semibold text-uppercase">{{"FIND_OUT" | translate}}</p>
                        <i class="fa-solid fa-arrow-right pb-4" aria-hidden="true"
                            [ngClass]="block.field_immagine ? 'text-neutral-A1' : 'text-brand-40'"></i>
                    </div>
                </div>
            </a>
        </div>
    </div>
    <app-sample-print [imageUrl]="block.field_immagine ? imgPath : ''" [taxonomy]="taxonomies" [title]="dataTitle.title"></app-sample-print>
</div>